import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/pages/Home' //首页
import Group_overview from '@/pages/Group_overview' //集团概况
import Coreplate from '@/pages/Coreplate' //核心版块
import Dqgy from '@/pages/Dqgy' //党群公益
import Fzmemorabilia from '@/pages/Fzmemorabilia' //发展大事纪
import New_list from '@/pages/New_list' //新闻中心
import New_detail from '@/pages/New_detail' //新闻详情
import Shop from '@/pages/Shop'
import Periodical from '@/pages/Periodical'
import Publication_list from '@/pages/Publication_list'
import Digital_cultural_legacy from '@/pages/Digital_cultural_legacy'
import Digital_cultural_detail from '@/pages/Digital_cultural_detail'

import Video from '@/pages/video/index'
import Studio from '@/pages/video/studio'
import List from '@/pages/transfer/list'
import ClassList from '@/pages/transfer/classlist'
import Hot from '@/pages/transfer/hotList'
import Search from '@/pages/transfer/searchList'
import Photo from '@/pages/book/photo'
import PhotoBak from '@/pages/book/photo-bak'
import Voice from '@/pages/book/voice'
import Photo2 from '@/pages/book/photo2'
import Student from '@/pages/inside/student'
Vue.use(Router)


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }


export default new Router({
  routes: [
    {
      path:'/',
      name: 'Home',
      component:Home,
      meta:{title: '首页'}
    },
    {
      path:'/home',
      name: 'Home',
      component:Home,
      meta:{title: '首页'}
    },
    {
      path: '/group_overview',
      name: 'Group_overview',
      component: Group_overview,
      meta:{title: '集团概况'}
    },
    
	
    {
      path: '/coreplate',
      name: 'Coreplate',
      component: Coreplate,
      meta:{title: '核心板块'}
    },
    {
      path: '/dqgy',
      name: 'Dqgy',
      component: Dqgy,
      meta:{title: '党建公益'}
    },
    {
      path: '/fzmemorabilia',
      name: 'Fzmemorabilia',
      component: Fzmemorabilia,
      meta:{title: '发展大事件'}
    },
    {
      path: '/new_list',
      name: 'New_list',
      component: New_list,
      meta:{title: '新闻中心'}
    },
    {
      path: '/shop',
      name: 'Shop',
      component: Shop,
      meta:{title: '品牌商城'}
    },
	{
	  path: '/digital_cultural_legacy',
	  name: 'Digital_cultural_legacy',
	  component: Digital_cultural_legacy,
	  meta:{title: '数字文物'}
	},
	{
	  path: '/digital_cultural_detail',
	  name: 'Digital_cultural_detail',
	  component: Digital_cultural_detail,
	  meta:{title: '文物详情'}
	},
	{
	  path: '/publication_list',
	  name: 'Publication_list',
	  component: Publication_list,
	  meta:{title: '刊物'}
	},	
	{
	  path: '/periodical',
	  name: 'Periodical',
	  component: Periodical,
	  meta:{title: '刊物'}
	},
    {
      path: '/new_detail',
      name: 'New_detail',
      component: New_detail,
      meta:{title: '新闻详情'}
    },
    {
      path: '/video',
      name: 'Video',
      component:Video,
      // meta:{title: '详情'}
    },
    {
      path: '/studio',
      name: 'Studio',
      component: Studio,
      meta:{title: '直播间'}
    },
	{
	  path: '/classlist',
	  name: 'ClassList',
	  component: ClassList,
	  meta:{title: '正佳乔心班'}
	},
	
    {
      path: '/list',
      name: 'List',
      component: List,
      meta:{title: '佳信官网'}
    },
	
    {
      path: '/hot',
      name: 'Hot',
      component: Hot,
      meta:{title: '热点聚焦'}
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta:{title: '搜索'}
    },
    {
      path: '/photo',
      name: 'Photo',
      component: Photo,
      meta:{title:'电子书'}
    },
	{
	  path: '/photo-bak',
	  name: 'PhotoBak',
	  component: PhotoBak,
	  meta:{title:'电子书'}
	},
    {
      path: '/voice',
      name: 'Voice',
      component: Voice,
      meta:{title:'语音播放'}
    },
	{
	  path: '/photo2',
	  name: 'Photo2',
	  component: Photo2,
	  meta:{title:'电子书2'}
	},
	{
	  path: '/student',
	  name: 'Student',
	  component: Student,
	  meta:{title:'电子书2'}
	},
  ]
})
